import { render, staticRenderFns } from "./RecipeView.vue?vue&type=template&id=55ec2565&scoped=true"
import script from "./RecipeView.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeView.vue?vue&type=style&index=0&id=55ec2565&prod&lang=scss&scoped=true"
import style1 from "./RecipeView.vue?vue&type=style&index=1&id=55ec2565&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ec2565",
  null
  
)

export default component.exports